import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithRedirect, encodePostRequest } from "features/api/utils/apiUtils.ts";
import endpoints, { baseURL } from "data/api/v1/endpoints.ts";
import {
	GetLeadAssignmentOptionsResponse,
	GetLeadAssignmentOptionsResponseData,
	GetLeadsResponse,
	GetLeadsResponseData
} from "features/LeadGen/api/leadGen.ts";

export const leadGenApiSlice = createApi({
	reducerPath: "leadGenApi",
	baseQuery: baseQueryWithRedirect(baseURL),
	tagTypes: ["LeadGen"],
	endpoints: (builder) => ({
		getLeads: builder.query<GetLeadsResponseData, void>({
			query: () => endpoints.leads.getLeads(),
			transformResponse: (response: GetLeadsResponse) => response?.data,
			providesTags: ["LeadGen"]
		}),
		getLeadAssignmentOptions: builder.query<GetLeadAssignmentOptionsResponseData, string>({
			query: (leadAssignmentId) => endpoints.leads.getLeadAssignmentOptions(leadAssignmentId),
			transformResponse: (response: GetLeadAssignmentOptionsResponse) => response?.data
		}),
		updateLeadAssignment: builder.mutation<void, { leadId: string; assignmentId: string; request: any }>({
			query: ({ leadId, assignmentId, request }) => ({
				url: endpoints.leads.updateLeadAssignment(leadId, assignmentId),
				method: "PATCH",
				dataType: "json",
				body: encodePostRequest(request)
			}),
			invalidatesTags: ["LeadGen"]
		})
	})
});

export const { useGetLeadsQuery, useGetLeadAssignmentOptionsQuery, useUpdateLeadAssignmentMutation } = leadGenApiSlice;
